<template>

    <div>
        <el-dialog
          title="入住须知"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          width="30%"
          >
        <div class="yj-pop-content">
          <div v-for="value in xzArray" :key="value.title">
            <div class="titleText confirm-text">{{ value.title }}</div>
            <div v-for="(item, index) in value.content" :key="index + '_jey'">
              <div class="confirm-text" v-if="value.html" v-html="item"></div>
              <div class="confirm-text" v-else>{{ item }}</div>
            </div>
          </div>
        </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="hasKown">我已知晓</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>

export default{
    props:{
        dialogVisible:{
            default:false,
            type:Boolean
        },
        currentRatePlan:{
            default:() => {},
            type:Object
        }
    },
    data(){
        return {
            content:'',
            xzArray:[]
        }
    },
    methods:{
        close(){
            this.$emit('close')
        },
        hasKown(){
            this.$emit('hasKown')
        }
    },
    watch: {
    '$props.currentRatePlan': {
        handler(newVal) {
            console.log(newVal,'newew');
            if (!newVal) {
                this.content = '';
                return;
            }
            let hotelPolicy = newVal.hotelPolicy || {};
            let array= [];
            for (const key in hotelPolicy) {
              const element = hotelPolicy[key].cn || [];
              // 入住
              let obj = {};
              obj.title = key;
              obj.content = [];
              obj.html = key == 'General';
              (element || []).forEach(item => {
                obj.content.push(item.description);
              })
              array.push(obj);
            }
            this.xzArray = array;
        },
        immediate: true
          }
        },
}

</script>

<style scoped lang="scss">
.custom-txt {
  background-image: linear-gradient(90deg, #69B3FF, #C5E2FF 100%);
  background-repeat: no-repeat;
  background-size: 100% 3px;
  background-position: 0 100%;
  padding-bottom: 0;
}

.yj-pop {
  border-radius: 16px;
  padding: 24px 0;
  // padding-bottom: 0;
  height: 100%;
  position: relative;
}
.top-bg {
  width: 114px;
  height: 114px;
  position: absolute;
  top: -40px;
  right: 30rpx;
  z-index: 510;
}
.yj-pop-header {
    height: 60px;
    padding: 0 16px;
    font-size: 24px;
    font-weight: bold;
}
.yj-pop-content {
  height: calc(100% - 110px);
  // padding-bottom: 30px;
  white-space: pre-wrap;
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.titleText{
    margin-top:8px;
    margin-bottom:8px;
    font-weight:600;
    font-size:16px;
    color:#222
}
.yj-pop-sub-footer {
  height: 30px;
  padding-top: 10px;
}
.yj-pop-footer {
  padding: 0 32rpx;
  height: 68px;
  // line-height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancel-text {
  width: 40%;
}
.confirm-text {
  width: 100%;
  text-align: left;
}
</style>